import {
    Container,
    Row,
    Col
} from 'reactstrap';
import clsx from "classnames";
import PropTypes from "prop-types";
import EditableImage from "@/components/EditableImage";
import EditableText from "@/components/EditableText";
import styles from './styles.module.scss';
import Link from "next/link"
import Form from "@/components/Shared/Form";
import sourceflowEnums from "@/sourceflow.enums";
import StarIcon from "@/public/site-assets/svg/star.svg";
import LightIcon from "@/public/site-assets/svg/light.svg";
import SocialShare from "@/components/Shared/SF_SocialShareCard_001";
import { useRouter } from 'next/router';
import Button from "@/components/Button";

import { motion } from 'framer-motion';
import React, { useRef, useState, useEffect } from 'react';
import JobCard from "@/components/Shared/JobCard";

export default function Sitemap({
    className,
    global,
    pathPrefix,
    post
}) {
    const router = useRouter();
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1 // Adjust threshold as needed, make it smaller for more sensitive detection
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            });
        }, options);

        observer.observe(sectionRef.current);

        // Cleanup function
        return () => {
            observer.disconnect();
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            const mobileDevice = window.innerWidth <= 991; // Adjust threshold for mobile devices
            // setIsVisible(!mobileDevice); // Hide motion on mobile devices
        };

        handleResize(); // Call initially
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            <section ref={sectionRef} className={clsx(className, styles.root)}>
                <Container>
                    <div className='d-flex flex-wrap wrapper'>
                        {post.map((post, index) =>
                            <motion.div initial={{ opacity: 0, y: 50 }} animate={isVisible ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5, delay: index * 0.1 }}>
                                <div>
                                    <Link href={`/${post.url_slug}`}>{post.title}</Link>
                                </div>
                            </motion.div>

                        )}
                    </div>
                </Container>
            </section>
        </>
    )
}

Sitemap.defaultProps = {
    pathPrefix: "",
    className: "py-5",


};

Sitemap.propTypes = {
    pathPrefix: PropTypes.string,
    className: PropTypes.string,
};